module.exports = __webpack_public_path__ + "images/favicons/favicon-momentum-32.03fab76d.png";